import { App } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { BodyOf } from "@/shared/api";
import { apiPatch, apiPost, errorMessage, qk } from "@/shared/api";
import type { paths } from "@/api/types";

export type AdminCreateBody = BodyOf<paths["/api/v1/admin/admins"]["post"]>;
export type AdminUpdateBody = BodyOf<paths["/api/v1/admin/admins/{admin_id}"]["patch"]>;

export function useCreateAdmin() {
  const queryClient = useQueryClient();
  const { message } = App.useApp();

  return useMutation({
    mutationFn: (body: AdminCreateBody) => apiPost("/api/v1/admin/admins", { body }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: qk.admins() });
      void queryClient.invalidateQueries({ queryKey: ["audit"] });
    },
    onError: (error) => {
      void message.error(errorMessage(error));
    },
  });
}

export function useUpdateAdmin() {
  const queryClient = useQueryClient();
  const { message } = App.useApp();

  return useMutation({
    mutationFn: (input: { id: number; body: AdminUpdateBody }) =>
      apiPatch("/api/v1/admin/admins/{admin_id}", {
        params: { admin_id: input.id },
        body: input.body,
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: qk.admins() });
      void queryClient.invalidateQueries({ queryKey: ["audit"] });
    },
    onError: (error) => {
      void message.error(errorMessage(error));
    },
  });
}
